import React from "react";
import { MyTimesheetMyRequestsDashboardCardPrint } from "my-timesheet/components";

interface DailyEntry {
  _id: string;
  name: string;
  description?: string;
  projectName?: string;
  clientName?: string;
  costName?: string;
  startTime: string;
  endTime: string;
  duration: string;
  rawDate: string;
  date: string;
  costBillable?: boolean;
}

interface MyTimesheetMyRequestsDashboardPrintProps {
  periodStart: string;
  employeeName: string;
  contractCode: string;
  hoursSummary: string;
  dailyEntries: DailyEntry[];
}

export class MyTimesheetMyRequestsDashboardPrint extends React.PureComponent<MyTimesheetMyRequestsDashboardPrintProps> {
  render() {
    const {
      periodStart,
      employeeName,
      contractCode,
      hoursSummary,
      dailyEntries,
    } = this.props;

    return (
      <MyTimesheetMyRequestsDashboardCardPrint
        periodStart={periodStart}
        employeeName={employeeName}
        contractCode={contractCode}
        hoursSummary={hoursSummary}
        dailyEntries={dailyEntries}
      />
    );
  }
}

export default MyTimesheetMyRequestsDashboardPrint;
